import { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { GiftIcon, XIcon, ArrowRightIcon } from 'lucide-react';
import { useExitIntent, markCheckoutStarted } from '../hooks/useExitIntent';
import { trackCheckoutClick } from './MetaPixel';
const SPECIAL_OFFER_URL = 'https://megapack-funcional-365.impultienda.ar/oferta-especial?store_id=a05de338-cc10-4d6b-9493-061df4fb0b81';
export function ExitIntentModal() {
  const {
    closeOffer,
    isOpen
  } = useExitIntent();
  const dialogRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeOffer();
        return;
      }
      if (event.key !== 'Tab' || !dialogRef.current) return;
      const focusable = Array.from(dialogRef.current.querySelectorAll<HTMLElement>('a[href], button:not([disabled])'));
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [closeOffer, isOpen]);
  return <AnimatePresence data-id="element-163" data-mp="w465yxequg5e">
      {isOpen && <motion.div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/80 p-4 backdrop-blur-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} role="presentation" data-id="element-164" data-mp="1a1unpwdil768">
          <motion.div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="exit-offer-title" aria-describedby="exit-offer-description" className="relative w-full max-w-md rounded-3xl border border-sky-400/40 bg-slate-900 p-6 text-center shadow-2xl shadow-blue-950/50 md:p-8" initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-165" data-mp="2giyc0sr5zukp">
            <button ref={closeButtonRef} type="button" onClick={closeOffer} className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-slate-400 transition-colors duration-150 hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" aria-label="Cerrar oferta exclusiva" data-id="element-166" data-mp="zgw8wdo864p6">
              <XIcon size={18} aria-hidden="true" data-id="element-167" data-mp="gn0g57i7bbzj" />
            </button>

            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-400/10 text-sky-400" data-id="element-168" data-mp="952lg94oi5gd">
              <GiftIcon size={28} aria-hidden="true" data-id="element-169" data-mp="44xzi3l04iir" />
            </div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-widest text-sky-400" data-id="element-170" data-mp="3vb8xfqupt35v">
              Oferta exclusiva por ahora
            </p>
            <h2 id="exit-offer-title" className="mb-4 font-display text-3xl font-black uppercase italic leading-[1.05] tracking-tight text-white md:text-4xl" data-id="element-171" data-mp="3mcvwg0wb9hmm">
              ¡Espera! Tenemos un regalo para ti
            </h2>
            <p id="exit-offer-description" className="mx-auto mb-6 max-w-sm text-[15px] leading-relaxed text-slate-300" data-id="element-172" data-mp="3ck80f8d5nhoy">
              Antes de irte, mira esta oferta exclusiva con un descuento que solo
              está disponible ahora. Pagas en tu moneda local.
            </p>

            <div className="flex flex-col gap-3" data-id="element-173" data-mp="2ynl1x15k0jgx">
              <a href={SPECIAL_OFFER_URL} onClick={e => {
            markCheckoutStarted();
            trackCheckoutClick(e, SPECIAL_OFFER_URL, 'megapack');
          }} className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-blue-600 px-6 py-4 text-[15px] font-bold uppercase tracking-wide text-white shadow-[0_10px_30px_-10px_rgba(37,99,235,0.8)] transition-[transform,background-color] duration-200 ease-out hover:bg-blue-500 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900" data-id="element-174" data-mp="12j4zp1qkzv6a">
                Ver oferta <ArrowRightIcon size={18} aria-hidden="true" data-id="element-175" data-mp="etkgchqimvwh" />
              </a>
              <button type="button" onClick={closeOffer} className="inline-flex w-full items-center justify-center rounded-full border border-white/10 px-6 py-3.5 text-sm font-semibold text-slate-400 transition-colors duration-150 hover:bg-white/5 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" data-id="element-176" data-mp="2490j9fdujldx">
                No, gracias
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}